import { render, staticRenderFns } from "./BankReport.vue?vue&type=template&id=400eb573&scoped=true"
import script from "./BankReport.vue?vue&type=script&lang=js"
export * from "./BankReport.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=400eb573&prod&scoped=true&lang=css&external"
import style1 from "./BankReport.vue?vue&type=style&index=1&id=400eb573&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400eb573",
  null
  
)

export default component.exports